var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input-default data-hj-allow",class:_vm.inputClass,attrs:{"type":"text","name":_vm.id,"id":_vm.id,"placeholder":_vm.placeholder,"autocomplete":"off"},on:{"input":_vm.inputTyping}})}
var staticRenderFns = []

export { render, staticRenderFns }